// Eje 1 — Elemento: dónde se VE el hallazgo (EL-01..10). No determina
// la categoría: una mancha en el cielo puede ser IMP, INS o CLI.
export const ELEMENTOS = [
    { codigo: "EL-01", nombre: "Muro" },
    { codigo: "EL-02", nombre: "Cielo" },
    { codigo: "EL-03", nombre: "Piso" },
    { codigo: "EL-04", nombre: "Puerta" },
    { codigo: "EL-05", nombre: "Ventana" },
    { codigo: "EL-06", nombre: "Mueble" },
    { codigo: "EL-07", nombre: "Artefacto" },
    { codigo: "EL-08", nombre: "Instalación / punto" },
    { codigo: "EL-09", nombre: "Baranda / antepecho" },
    { codigo: "EL-10", nombre: "Cubierta" },
];
//# sourceMappingURL=elementos.js.map